export const RoutePaths = {
  // Navigation routes
  home: '/',
  splash: '/splash',
  intro: '/intro',

  // Game routes
  game_lights: '/game_lights',
  game_heater: '/game_heater',
  game_quizz_01: '/game_quizz_01',
  game_quizz_02: '/game_quizz_02',

  // End routes
  thanks: '/thanks',
  outro: '/outro',

  // Test routes
  test3d: '/test',
  about: '/about',
} as const;
